"use client";

import Image from "next/image";

export default function BackgroundTexture() {
  return (
    <Image
      src="/img/texture/splatter_texture.png"
      width={1920}
      height={1080}
      alt="Hintergrund Textur"
      sizes="100vw"
      className="fixed top-0 left-0 size-full object-cover object-top-center -z-1"
    />
  );
}
